/**
 * ajax 模块，可以将 axios 替换成 $.ajax 等
 */
import axios from 'axios';
import globalConfig from '../config'

const GET_LANGUAGE_TYPE = '/get/i18n_type'
const GET_I18N = '/static/i18n/'
const GET_HEADER_LIST = '/headerList'
const PERMISSION_CHECK = '/permissionCheck'

const init = function () {
  axios.interceptors.request.use(function (config) {
    // if (config.method === 'get' || 'post') {
    //   config.url += ('?access_token=' + (window.localStorage.access_token || ''));
    //   // config.url += ('?access_token=' + (window.localStorage.access_token || '') + '&path=' + location.href);
    // } else {
    //   if (!config.data) config.data = {};
    //   config.data['access_token'] = window.localStorage.access_token || '';
    //   config.data['path'] = location.href || '';
    // }
    if (config.url.indexOf(GET_LANGUAGE_TYPE) < 0 &&
      config.url.indexOf(GET_HEADER_LIST) < 0 &&
      config.url.indexOf(GET_I18N) < 0 &&
      config.url.indexOf(PERMISSION_CHECK) < 0) {
      config.url = window.localStorage.gatewayDomain + config.url
    }
    var cookies = globalConfig.getCookies()
    if (config.url.indexOf('?') < 0) {
      config.url += '?'
    }
    config.url += ('access_token=' + cookies['access_token'])
    if (!config.data) config.data = {}
    return config;
  }, function (err) {
    return Promise.reject(err)
  })

  // Add a response interceptor
  axios.interceptors.response.use(function (response) {
    const {status, data} = response;

    if (status === 200) {
      // 如果不出现错误，直接向回调函数内输出 data
      if (data.error === 'SUCCESS') {
        return data
      } else {
        return data
      }
    } else {
      return response;
    }
  }, function (error) {
    const {response} = error;

    // 这里处理错误的 http code
    if (response.status === 404) {
      console.log('404 error %o' + error);
    }

    // Do something with response error
    return Promise.reject(error);
  });
};

export default {
  init
}



// WEBPACK FOOTER //
// ./src/services/ajax.js